var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M25 0H10C4.47715 0 0 4.47715 0 10V25C0 30.5228 4.47715 35 10 35H25C30.5228 35 35 30.5228 35 25V10C35 4.47715 30.5228 0 25 0Z",
    fill: "#D3FF9A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_325_4798)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1026 26C15.9251 26 15.7552 25.9564 15.5931 25.8692C15.2843 25.6948 15.099 25.3896 15.099 25.0554V21.3061C15.099 20.376 14.7284 19.4896 14.049 18.8211C14.0336 18.8065 14.0104 18.792 13.995 18.7775L9.77975 14.5413C9.27793 14.04 9 13.3787 9 12.6885V11.9183C9 10.8647 9.90327 10 11.015 10H23.985C25.0967 10 26 10.8647 26 11.9183V12.6885C26 13.3787 25.7221 14.04 25.2203 14.5413L20.9973 18.7702C20.3025 19.446 19.9242 20.3397 19.9242 21.2843V23.1589C19.9242 23.7766 19.569 24.3506 18.99 24.6412L16.5813 25.8765C16.4269 25.9564 16.2648 25.9927 16.1026 25.9927V26ZM14.9137 17.8765C14.9137 17.8765 14.9369 17.8983 14.9523 17.9128C15.8942 18.8211 16.4114 20.02 16.4114 21.2988V24.5686L18.3647 23.5658C18.5191 23.4859 18.6117 23.3333 18.6117 23.1662V21.2916C18.6117 20.02 19.1213 18.8283 20.0554 17.9201L24.2784 13.6985C24.5486 13.4223 24.703 13.0663 24.703 12.6885V11.9183C24.703 11.5404 24.3865 11.228 23.9927 11.228H11.015C10.6213 11.228 10.3047 11.5404 10.3047 11.9183V12.6885C10.3047 13.0663 10.4514 13.4223 10.7293 13.6985L14.906 17.8837L14.9137 17.8765Z",
    fill: "#D3FF9A"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.3794 14.5121H15.7198C15.3766 14.5121 15.0991 14.236 15.0991 13.8945C15.0991 13.553 15.3766 13.2769 15.7198 13.2769H24.3794C24.7225 13.2769 25 13.553 25 13.8945C25 14.236 24.7225 14.5121 24.3794 14.5121Z",
    fill: "#D3FF9A"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_325_4798"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 16,
    fill: "white",
    transform: "translate(9 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.76d8ddf0f5e5945fbf74b4df63135e6f.svg";
export { ForwardRef as ReactComponent };